import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=f50d3f1c&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports